// extracted by mini-css-extract-plugin
export default {"time":"BonusTimer__time--slots-MBdfo","icon":"BonusTimer__icon--slots-IPq2S"};